<template>
    <div class="home">
        <img src="https://guokrapp-static.guokr.com/FrKF0AavXhbspCdIdD6YFZpjuUlo" alt="" class="bg">
        <div class="banner"></div>
        <div class="home-content">
            <div class="q-buttons">
                <div class="main-button" @click="() => handleRouter('daily')">{{`每日答题 (${user.new_agri_daily_quiz_times}/${agriMaxDailyTime})`}}</div>
                <div class="main-button" @click="() => handleRouter('challenge')">{{`进阶挑战 (${user.new_agri_challenge_quiz_times}/${agriMaxChallengeTime})`}}</div>
                <div class="main-button" @click="() => handleRouter('articles', false)">{{`科普文章`}}</div>
                <div class="main-button" @click="() => handleRouter('fun', false)">{{`趣味任务`}}</div>
                <div class="main-button large" @click="() => handleRouter('me')">{{`个人中心`}}</div>
            </div>
            <!-- <div class="t-buttons">
                <div class="main-button" @click="() => handleRouter('top')">排行榜</div>
            </div>
            <div class="o-buttons">
                <div class="main-button" @click="() => handleRouter('activity', false)">活动说明</div>
                <div class="main-button" @click="() => handleRouter('me')">个人中心</div>
            </div> -->
            <!-- <span class="test" @click="() => handleRouter('test', false)">网络科学素质测试>>></span> -->
            <img class="info" src="https://guokrapp-static.guokr.com/FmbFhOs53mW7s7SHDZu-qQq0Hbyd"/>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant'
import { userApi } from '@/apis'

const BUTTON_ROUTE_MAP = {
    daily: '/quiz/agriculture/rules/daily',
    challenge: '/quiz/agriculture/rules/challenge',
    top: '/quiz/top',
    me: '/quiz/agriculture/me',
    articles: '/quiz/agriculture/articleClassify',
}

export default {
    name: 'home',
    data () {
        return {
            agriMaxDailyTime: 0,
            agriMaxChallengeTime: 0,
            user: {
                new_agri_daily_quiz_times: 0,
                new_agri_challenge_quiz_times: 0
            },
            agriInterestingTaskHref: '',
        }
    },
    methods: {
        async handleRouter (routeName, needAuth = true) {
            try {
                needAuth && await this.$auth.check({ closable: true, source: 'agriculture' })
                // 需要检测次数
                if (routeName === 'daily') {
                    await this.getInfo()
                    if (this.user.new_agri_daily_quiz_times >= this.agriMaxDailyTime) return Toast.fail('今日答题次数用完啦，明天记得回来看看')
                } else if (routeName === 'challenge') {
                    await this.getInfo()
                    if (this.user.new_agri_challenge_quiz_times >= this.agriMaxChallengeTime) return Toast.fail('今日挑战次数用完啦，明天记得回来看看')
                } else if (routeName === 'fun') {
                    if (this.agriInterestingTaskHref) {
                        window.location.assign(this.agriInterestingTaskHref)
                    }
                    return 
                }
                const route = BUTTON_ROUTE_MAP[routeName]
                this.location.push(route)
            } catch {
                console.log('cancel')
            }
        },
        async getInfo () {
            const logined = await this.$auth.check({ showModal: false, source: 'agriculture' })
            if (logined) {
                const { body } = await userApi.userUidGet({
                    params: {
                        uid: logined
                    }
                })
                this.user = body
            }
        },
        async getConfig () {
            Object.assign(this, await this.GLOBAL.getConfig('agriMaxDailyTime,agriMaxChallengeTime,agriInterestingTaskHref'))
        },
    },
    mounted () {
        this.getConfig()
        this.getInfo()
    },
} 
</script>
<style lang="less">
.van-toast {
    width: auto;
    max-width: 75%;
    .van-toast__text {
        white-space: pre;
    }
}
</style>
<style lang="less" scoped>
.home {
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    position: relative;
    color: #082754;
    font-size: 16px;
    line-height: 1em;
    img.bg {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center 0;
        position: absolute;
        z-index: -1;
    }
    .home-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        width: 100%;
        bottom: 0;
        .main-button {
            border-radius: 0.8rem;
            white-space: pre-line;
            border: none;
            font-size: inherit;
            text-align: center;
        }
        .q-buttons {
            height: 130px;
            width: 77%;
            display: flex;
            justify-content: space-between;
            align-content: space-between;
            flex-wrap: wrap;
            margin-bottom: 10vh;
            .main-button {
                width: 48%;
                background-color: #fff;
                height: 36px;
                line-height: 36px;
                color: #123E7F;
                font-weight: bold;
                &.large {
                    width: 100%
                }
            }
        }
        .t-buttons {
            .main-button {
                background-color: #01bb8a;
                color: #fff;
                padding: 1.35rem 0;
            }
        }
        .o-buttons {
            .main-button {
                background-color: #fff;
                padding: 2.1rem 0;
                &:last-child {
                    margin-left: 1.4rem;
                }
            }
        }
        .test {
            margin: 1rem 0;
            font-size: 18px;
            line-height: 1.5;
        }
        .info {
            width: 14%;
            margin-bottom: 4.5vh;
        }
    }
}
</style>
